import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { SnackbarError } from "../../components/base/SnackbarAlert/SnackbarError";
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import { useDeleteProductMutation } from "../../services/productsService";

export function ProductDeleteButton({ product }) {
    const { t } = useTranslation();
    const { mutate: deleteProduct } = useDeleteProductMutation({
        onSuccess: () => {
            toast.custom(() => (
                <SnackbarSuccess message={t("products.productDeletedSuccessfully")} />
            ));
        },
        onError: (error) => {
            console.error("Error deleting product:", error);
            toast.custom(() => <SnackbarError message={t("products.failedToDeleteProduct")} />);
        },
    });

    const handleDelete = (e) => {
        e.stopPropagation();

        const confirmed = window.confirm(
            t("products.deleteConfirmMessage", {
                productName: product.name_full,
            }),
        );

        if (confirmed) {
            deleteProduct({ productId: product.id });
        }
    };

    return (
        <IconButton color="error" onClick={handleDelete} title={t("products.delete")}>
            <DeleteIcon />
        </IconButton>
    );
}
